import type {ReactNode} from 'react'

export const getPageContentByKey = ({
  content,
  key,
  defaultPage,
}: {
  content: Record<string, ReactNode>
  key: string
  defaultPage: ReactNode
}): ReactNode => content[key] ?? defaultPage

export const convertToTitleCase = (str: string): string =>
  str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()

export const secondsToHM = (s: number): string => {
  const hours = Math.floor((s % (3600 * 24)) / 3600)
  const minutes = Math.floor((s % 3600) / 60)
  const seconds = Math.floor((s % 3600) % 60)

  if (hours && minutes) return `${hours} hours ${minutes} minutes`
  if (minutes || seconds > 30) {
    const m = minutes || 1
    return `${m} ${m === 1 ? 'minute' : 'minutes'}`
  }
  return 'No login'
}

export const getTimePassed = (dateString: string): string => {
  const given = new Date(dateString)
  const now = new Date()

  const diffMs = now.getTime() - given.getTime()
  const diffMinutes = Math.floor(diffMs / (1000 * 60))
  const diffHours = Math.floor(diffMinutes / 60)
  const diffDays = Math.floor(diffHours / 24)

  if (diffMinutes < 60 && diffDays === 0)
    return `about ${diffMinutes} ${
      diffMinutes === 1 ? 'minute' : 'minutes'
    } ago`

  if (diffHours < 24 && diffDays === 0)
    return `about ${diffHours} ${diffHours === 1 ? 'hour' : 'hours'} ago`

  if (diffDays < 10)
    return `about ${diffDays} ${diffDays === 1 ? 'day' : 'days'} ago`

  return 'created on ' + given.toDateString()
}

export const getHexFromColorText = (color: string): string => {
  const ctx = document.createElement('canvas').getContext('2d')!
  ctx.fillStyle = '#d8d8d8'
  ctx.fillStyle = color
  const hex = ctx.fillStyle
  return hex
}

export const stringUtil = {
  getPageContentByKey,
  convertToTitleCase,
  secondsToHM,
  getTimePassed,
  getHexFromColorText,
} as const
